import { useState } from 'react';
import CodeBlock from './CodeBlock';
import { BASE_URL } from '../data/constants';

export default function EndpointDetail({ endpoint }) {
  const [urlCopied, setUrlCopied] = useState(false);
  const fullUrl = `${BASE_URL}${endpoint.path}`;

  async function copyUrl() {
    try {
      await navigator.clipboard.writeText(fullUrl);
      setUrlCopied(true);
      setTimeout(() => setUrlCopied(false), 1500);
    } catch {
      // Clipboard API unavailable — fail silently.
    }
  }

  return (
    <article className="endpoint-detail">
      <header className="endpoint-header">
        <span className={`method-tag method-tag--lg method-${endpoint.method.toLowerCase()}`}>
          {endpoint.method}
        </span>
        <h1>{endpoint.name}</h1>
      </header>

      {endpoint.description && <p className="endpoint-description">{endpoint.description}</p>}

      <div className="endpoint-url-bar">
        <code>{fullUrl}</code>
        <button type="button" onClick={copyUrl}>
          {urlCopied ? 'Copied' : 'Copy URL'}
        </button>
      </div>

      <div className="endpoint-auth-note">
        <span className="lock-icon" aria-hidden="true">
          &#128274;
        </span>
        This endpoint requires HTTP Basic Authentication. Use the credentials shared with you on
        a separate document &mdash; they are not shown here.
      </div>

      {endpoint.queryParams.length > 0 && (
        <section className="endpoint-section">
          <h2>Query Parameters</h2>
          <div className="params-table-wrap">
            <table className="params-table">
              <thead>
                <tr>
                  <th>Parameter</th>
                  <th>Example</th>
                  <th>Required</th>
                </tr>
              </thead>
              <tbody>
                {endpoint.queryParams.map((p) => (
                  <tr key={p.key}>
                    <td>
                      <code>{p.key}</code>
                    </td>
                    <td>{p.example ? <code>{p.example}</code> : <span className="muted">&mdash;</span>}</td>
                    <td>
                      {p.required ? (
                        <span className="badge badge--required">Required</span>
                      ) : (
                        <span className="badge badge--optional">Optional</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      )}

      {endpoint.requestBody && (
        <section className="endpoint-section">
          <h2>Request Body</h2>
          <CodeBlock code={endpoint.requestBody} label="JSON Body" />
        </section>
      )}

      {endpoint.responseExample && (
        <section className="endpoint-section">
          <h2>Example Response</h2>
          <CodeBlock
            code={endpoint.responseExample.body}
            label={`${endpoint.responseExample.code} ${endpoint.responseExample.status}`}
          />
        </section>
      )}
    </article>
  );
}
